import React from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';

import { MuiTheme, StyledTheme } from 'theme';

const StyleProvider: React.FunctionComponent<{ children: React.ReactNode }> = ({ children }): React.ReactElement => (
  <MuiThemeProvider theme={MuiTheme}>
    <StyledThemeProvider theme={StyledTheme}>{children}</StyledThemeProvider>
  </MuiThemeProvider>
);

export default StyleProvider;
